import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import cn from 'classnames';
import {
  Modal,
  ModalButtons,
  ModalContent,
  Button,
  ProgressBar,
  withForm,
  Label,
  TextField,
} from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import Yup from 'yup';
import { SUPPORT_SEND } from 'constants';
import mes from './intl';
// eslint-disable-next-line no-unused-vars
import sModal from '../../Modal.scss'; // NOSONAR
// eslint-disable-next-line no-unused-vars
import sLocal from './ContactUs.scss'; // NOSONAR

class ContactUs extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tFocus: false,
    };
  }

  // Ф-ция локализации
  i(mesId, values) {
    return AppUtils.getMes(this.context)(mesId, values);
  }

  render() {
    const {
      values,
      errors,
      visibility,
      onClose,
      handleSubmit,
      handleOnChange,
      isSubmit,
    } = this.props;
    return (
      <Modal
        styleName="sModal.modal"
        visibility={visibility}
        onClose={onClose}
        label={this.i(mes.pleaseContactUs)}
      >
        <ModalContent styleName="sModal.modal__content">
          <div styleName="sLocal.row">
            <TextField
              styleName={cn('sModal.textfield', 'sLocal.name')}
              id="name"
              label={this.i(mes.name)}
              bordered={true}
              size="large"
              value={values.name || ''}
              helperText={errors.name ? this.i(mes[errors.name]) : ''}
              error={!!errors.name}
              onChange={handleOnChange}
            />
            <TextField
              styleName={cn('sModal.textfield', 'sLocal.textfield')}
              id="email"
              label="Email"
              bordered={true}
              size="large"
              value={values.email || ''}
              helperText={errors.email ? this.i(mes[errors.email]) : ''}
              error={!!errors.email}
              onChange={handleOnChange}
            />
          </div>
          <div styleName="sLocal.row">
            <TextField
              styleName={cn(
                'sModal.textfield',
                'sLocal.textfield',
                'sLocal.subject'
              )}
              id="subject"
              label={this.i(mes.subject)}
              bordered={true}
              size="large"
              value={values.subject || ''}
              helperText={errors.subject ? this.i(mes[errors.subject]) : ''}
              error={!!errors.subject}
              onChange={handleOnChange}
            />
          </div>
          <Label
            styleName={cn('sModal.label', 'sLocal.textarea__label')}
            fontSize="medium"
            value={this.i(mes.message)}
          />
          <textarea
            name="text"
            styleName={cn('sLocal.textarea', { 'sLocal.error': !!errors.text })}
            id="text"
            value={values.text || ''}
            onFocus={() => this.setState({ tFocus: true })}
            onBlur={() => this.setState({ tFocus: false })}
            onChange={(e) =>
              handleOnChange({
                id: 'text',
                value: e.target.value,
                error: errors.text,
              })
            }
          />
          <Label
            styleName="sLocal.textarea__error"
            fontSize="small"
            value={this.i(mes[errors.text])}
          />
        </ModalContent>
        <ModalButtons styleName="sModal.modal__buttons">
          <Button
            label={this.i(mes.sendMessage)}
            size="large"
            onClick={handleSubmit}
            visibility={isSubmit ? 'disabled' : 'visible'}
          />
          <ProgressBar
            styleName="sModal.modal__loader"
            type="circle"
            size="small"
            visibility={isSubmit ? 'visible' : 'hidden'}
          />
        </ModalButtons>
      </Modal>
    );
  }
}

const FormContactUs = withForm(
  {
    mapPropsToValues(props) {
      return {
        name: props.auth.nick,
        email: props.auth.login,
      };
    },
    yup: Yup.object().shape({
      name: Yup.string().required('field_required'),
      email: Yup.string().email('valid_email').required('field_required'),
      subject: Yup.string().required('field_required'),
      text: Yup.string().required('field_required'),
    }),
    handleSubmit: (values, dispatch, formActions, props) => {
      formActions.onClose = props.onClose;
      dispatch({
        type: SUPPORT_SEND.REQUEST,
        payload: values,
        formActions,
      });
    },
  },
  ContactUs
);

ContactUs.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleOnChange: PropTypes.func,
  isSubmit: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
};

ContactUs.contextTypes = {
  intl: intlShape,
};

export default injectIntl(FormContactUs);
